<mat-form-field>
  <input type="text" placeholder="{{ placeholder + (isRequired ? ' *' : '') }}" matInput [matAutocomplete]="auto" [formControl]="inputControl" />
  <mat-icon *ngIf="suggestControl?.value && !suggestControl?.disabled && !disableDelete" matSuffix (click)="clearSelection()">delete</mat-icon>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.label }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
